const containsLetters = ({
  value = ''
}) => {
  return !!value.match('(?=.*[a-zA-Z])');
};
const containsLowercase = ({
  value = ''
}) => {
  return !!value.match('(?=.*[a-z])');
};
const containsNumber = ({
  value = ''
}) => {
  return !!value.match('(?=.*[0-9])');
};
const containsSpecialChar = ({
  value = ''
}) => {
  return !!value.match('(?=.*[!@#$%^&*])');
};
const containsValidCharsOnly = ({
  value = ''
}) => {
  return !value.match('(?=.*[+-\\s])');
};
const containsCognitoValidSpecialChars = data => {
  return containsValidCharsOnly(data) && containsSpecialChar(data);
};
const containsUppercase = ({
  value = ''
}) => {
  return !!value.match('(?=.*[A-Z])');
};
const isEmail = ({
  value = ''
}) => {
  if (value) {
    const validEmailRegex = /\S+@\S+\.\S+/;
    return validEmailRegex.test(value);
  }

  // Don't fail on an empty email
  return true;
};
const isMin12Chars = ({
  value = ''
}) => {
  return [...value.toString()].length >= 12;
};
const isNumeric = ({
  value
}) => {
  return !isNaN(value);
};
const isPassword = data => {
  return isNotEmpty(data) && containsNumber(data) && containsLowercase(data) && containsUppercase(data) && containsSpecialChar(data) && containsValidCharsOnly(data) && isMin12Chars(data);
};
const isNotEmpty = ({
  value
}) => {
  return !(value === '' || value === null || value === undefined);
};
const isUSD = ({
  value = ''
}) => {
  const validCurrencyRegex = /^(\d*)(\.\d{0,2})?$/;
  return validCurrencyRegex.test(value);
};
module.exports = {
  containsLetters,
  containsLowercase,
  containsNumber,
  containsSpecialChar,
  containsValidCharsOnly,
  containsCognitoValidSpecialChars,
  containsUppercase,
  isEmail,
  isMin12Chars,
  isNumeric,
  isNotEmpty,
  isPassword,
  isUSD
};